module.exports = __webpack_public_path__ + "img/img24.35275785.svg";